export default {"src":"/kaimono/_next/static/media/warning.d34f05d1.svg","height":36,"width":36};